import { render, staticRenderFns } from "./Suppliersform.vue?vue&type=template&id=f6730180"
import script from "./Suppliersform.vue?vue&type=script&lang=js"
export * from "./Suppliersform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports